module.exports = __webpack_public_path__ + "static/img/2-info.8d083ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/2-info.png
// module id = 90aQ
// module chunks = 0